import { Box, Stack, Typography } from '@mui/material';

type VisitModalEmptyStateProps = {
  message: string;
};

export default function VisitModalEmptyState({
  message,
}: VisitModalEmptyStateProps) {
  return (
    <Stack
      sx={{
        width: '100%',
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        gap: 1.5,
      }}
    >
      <Box
        component="img"
        src="/assets/illustrations/laptop-paw-blue.svg"
        alt="empty"
        sx={{ width: 110, height: 'auto', display: 'block' }}
      />
      <Typography variant="body2" color="text.secondary">
        {message}
      </Typography>
    </Stack>
  );
}
